module.exports = __webpack_public_path__ + "static/media/suso.ba47718f.jpg";